import React from 'react';
import PropTypes from 'prop-types';
import Canvas from "./Canvas";
import {
  IZO_TRANSFORM_A,
  IZO_TRANSFORM_B,
  IZO_TRANSFORM_C,
  IZO_TRANSFORM_D
} from "../../utils/Constant";
//import * as HelperCanvas from '../../utils/HelperCanvas'; прячем, т.к. пока обходимся линейной коррекцией, см. getActivePoints


const offsetX= 45;
const offsetY= -80;
class SiteCustom extends Canvas {

  constructor(props) {

    super(props);

    this.activePoints = this.getActivePoints(props.props);
    this.extentPoints = this.getExtentPoints();
    this.dropPoints = this.getDropPoints();
    this.selectedLines = [];

  }

  componentDidMount() {
    this.ctx = this.refs.siteCustom.getContext('2d');
    this.draw();
  }

  componentDidUpdate(prevProps, prevState) {

    const {position, oldPosition} = prevProps;

    if (position !== this.props.position) {

      if (oldPosition) {
        this.moveTo(position.x - oldPosition.x, position.y - oldPosition.y);
      }

      this.reCalcActivePoints();
      this.reCalcExtentPoints();
      this.reCalcDropPoints();
      this.draw();
    }

    if (prevProps.coordinates !== this.props.coordinates) {
      this.reCalcActivePoints();
      this.reCalcExtentPoints();
      this.reCalcDropPoints();
      this.draw();
    }

  }

  getActivePoints = (coordinates = this.props.coordinates) => {

    let result = [];
    coordinates = this.getRealCoordinates(coordinates);

    /*for (let i = 0; i < coordinates.length; i++) {
     result.push({
       x: (coordinates[i].x * 0.55 + coordinates[i].y * 0.9 + this.props.position.x / this.props.sizes.scale),
       y: (coordinates[i].x * 0.64 - coordinates[i].y * 0.35 + this.props.position.y / this.props.sizes.scale)
     });
   }*/

    //let x = 0.55, y = 0.64, z = 0.9, s = 0.35;
    let x = IZO_TRANSFORM_A,   //scale по горизонтали
      y = IZO_TRANSFORM_B,     //на N пикселей вниз
      z = IZO_TRANSFORM_C,     //каждая следующая строчка будет смещена на N пиксель вправо, относительно предыдущей.
      s = -IZO_TRANSFORM_D;   //scale по вертикали (минус, поскольку в константах тоже задан минус)

    if (this.props.viewTop) {
      for (let i = 0; i < coordinates.length; i++) {
        //       let topViewXY = HelperCanvas.calculateBackTransform(
        //         this.props.position.x / this.props.sizes.scale + coordinates[i].x,
        //         this.props.position.y / this.props.sizes.scale + coordinates[i].y,
        //         x,y,z,s, this.props.sizes.scale);
        //       result.push({
        //         x: topViewXY.y,
        //         y: topViewXY.x
        //       });
        //     } не доведен до заверешения как в site.jsx, нужно брать из equipment. // Поэтому пока по старому через коэффициенты 0/1/1/0 + сдвиг offsetX/offsetY
      }
      x = 0;
      y = 1;
      z = 1;
      s = 0;
      for (let i = 0; i < coordinates.length; i++) {
        result.push({
          x: (coordinates[i].x * x + coordinates[i].y * z + this.props.position.x / this.props.sizes.scale + offsetX),
          y: (coordinates[i].x * y - coordinates[i].y * s + this.props.position.y / this.props.sizes.scale - offsetY)
        });
      }

    } else {
      for (let i = 0; i < coordinates.length; i++) {
        result.push({
          x: (coordinates[i].x * x + coordinates[i].y * z + this.props.position.x / this.props.sizes.scale),
          y: (coordinates[i].x * y - coordinates[i].y * s + this.props.position.y / this.props.sizes.scale)
        });
      }
    }

    return result;
  };

  getExtentPoints = () => {

    //this.props.coordinates

    let result = [];
    let pointsCount = this.activePoints.length;

    if (pointsCount > 0) {

      for (let i = 1; i < this.activePoints.length; i++) {
        result = [...result, ...this.marksDraw(this.activePoints[i], this.activePoints[i - 1], i)];
      }

      return [...result, ...this.marksDraw(this.activePoints[0], this.activePoints[this.activePoints.length - 1])];
    }


  };

  getDropPoints = () => {

    let result = [];
    const width = this.props.field.width * this.state.square + this.state.square * this.state.grassMod;
    const height = this.props.field.height * this.state.square + this.state.square * this.state.grassMod;
    const grassSize = this.state.square * this.state.grassMod;

    //let ctxA = 0.55, ctxB = 0.64, ctxC = 0.9, ctxD = 0.35;
    let ctxA = IZO_TRANSFORM_A, //scale по горизонтали
      ctxB = IZO_TRANSFORM_B,   //на N пикселей вниз
      ctxC = IZO_TRANSFORM_C,   //каждая следующая строчка будет смещена на N пиксель вправо, относительно предыдущей.
      ctxD = -IZO_TRANSFORM_D;   //scale по вертикали (минус, поскольку в константах тоже задан минус)

    if (this.props.viewTop) {
      //через HelperCanvas не доведен до ума, см. getActivePoints.
      // Поэтому пока через такие коэффициенты + сдвиг 45/offsetY
      ctxA = 0;
      ctxB = 1;
      ctxC = 1;
      ctxD = 0;
      for (let a = grassSize, x = 0; a <= width; a += this.state.square, x++) {

        for (let b = grassSize, y = 0; b <= height; b += this.state.square, y++) {
          result.push({
            x: (a * ctxA + b * ctxC + this.props.position.x / this.props.sizes.scale + offsetX),
            y: (a * ctxB - b * ctxD + this.props.position.y / this.props.sizes.scale - offsetY),
            relative: {x: x, y: y}
          });
        }
      }
    } else {

      for (let a = grassSize, x = 0; a <= width; a += this.state.square, x++) {

        for (let b = grassSize, y = 0; b <= height; b += this.state.square, y++) {
          result.push({
            x: (a * ctxA + b * ctxC + this.props.position.x / this.props.sizes.scale),
            y: (a * ctxB - b * ctxD + this.props.position.y / this.props.sizes.scale),
            relative: {x: x, y: y}
          });
        }
      }
    }

    return result;
  };

  checkLineSizes = (x, y) => {

    let selectedLinePoints = [];

    this.activePoints.concat(this.activePoints[0]).reduce((curr, next, index) => {

      let line = this.defineLineAsRect(curr, next);
      this.ctx.lineWidth = 2;
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.translate(line.translateX, line.translateY);
      this.ctx.rotate(line.rotation);
      this.ctx.rect(line.rectX, line.rectY, line.rectWidth, line.rectHeight);
      this.ctx.translate(-line.translateX, -line.translateY);
      this.ctx.rotate(-line.rotation);
      this.ctx.restore();

      if (this.ctx.isPointInPath(x, y)) {
        selectedLinePoints = [curr, next];
        this.selectedLines = [index];
      }

      return next;
    });

    this.draw();


    if (this.selectedLines.length) {

      let size = this.getLineSize(selectedLinePoints[0], selectedLinePoints[1]);

      if (size) {
        this.drawSizeLabel(size, x / this.props.sizes.scale, y / this.props.sizes.scale);
      }

      this.selectedLines = [];
    }

  };

  /**
   * Надпись размера границы
   * @param point1
   * @param point2
   * @param notSearchDrop
   * @return {string|null}
   */
  getLineSize = (point1, point2, notSearchDrop) => {

    let points = [];

    if (!notSearchDrop) {

      this.dropPoints.forEach((drop) => {

        if (point2) {
          if ((drop.x === point1.x && drop.y === point1.y) || (drop.x === point2.x && drop.y === point2.y)) {
            points.push(drop.relative)
          }
        }
      });

      points.filter((exts) => {
        return exts;
      });

    } else {
      points = [point1, point2];
    }

    if (points.length > 1) {

      const vector = {x: points[1].x - points[0].x, y: points[1].y - points[0].y};
      const module = Math.sqrt(Math.pow(vector.x, 2) + Math.pow(vector.y, 2));
      return module > 10 ? module.toPrecision(3) : module.toPrecision(2);

    } else {
      return null;
    }
  };

  round = (number, places) => {
    return +(Math.round(number + "e+" + places) + "e-" + places);
  };


  renderSelectableBorder = () => {

    this.activePoints.concat(this.activePoints[0]).reduce((curr, next, index) => {

      this.ctx.beginPath();

      if (this.selectedLines.indexOf(index) !== -1) {
        this.ctx.strokeStyle = "royalblue";
      } else {
        this.ctx.strokeStyle = "yellow";
      }

      this.ctx.moveTo(curr.x, curr.y);
      this.ctx.lineTo(next.x, next.y);

      this.ctx.stroke();
      this.ctx.closePath();
      return next;

    });

  }

  draw = () => {

    this.clear(true);

    this.ctx.scale(this.props.sizes.scale, this.props.sizes.scale);
    this.ctx.lineWidth = this.state.lineWidth;

    this.renderSelectableBorder();

    if (this.selectedLines.length === 2) {

      let lines = [];

      this.activePoints
        .concat(this.activePoints[0])
        .reduce((curr, next, index) => {
          if (this.selectedLines.indexOf(index) !== -1) {
            lines.push([curr, next]);
          }
          return next;
        });

      let sort = (a, b) => {
        if (a.x + a.y < b.x + b.y) {
          return -1;
        } else {
          return 1;
        }
      };

      let sizes = lines.map((points) => {

        let relative1 = this.dropPoints
          .map((drop) => {
            return {
              x: Math.abs(drop.x - points[0].x),
              y: Math.abs(drop.y - points[0].y),
              relative: drop.relative
            };
          })
          .sort(sort)[0].relative;

        let relative2 = this.dropPoints
          .map((drop) => {
            return {
              x: Math.abs(drop.x - points[1].x),
              y: Math.abs(drop.y - points[1].y),
              relative: drop.relative
            };
          })
          .sort(sort)[0].relative;

        return this.getLineSize(relative1, relative2, true);

      });

      console.log("%csizes", "color:red;font-weight:bold;", sizes);


      let line = !lines.length ? {} : lines.reduce((curr, next) => {
        let point = {};
        curr.forEach((p1) => {
          next.forEach((p2) => {
            if (p1.x === p2.x && p1.y === p2.y) {
              point = p1;
            }
          });
        });
        return point;
      });

      let extIndex = this.extentPoints.map((ext, index) => {
        return {x: Math.abs(ext.x - line.x), y: Math.abs(ext.y - line.y), index: index};
      })
        .sort(sort)[0].index;

      let dem = 0;
      let indexes = [extIndex - 2, extIndex + 2].map((index) => {
        if (index < 0) {
          // console.log('index < 0');
          return this.extentPoints.length + index;
        }

        if (index > this.extentPoints.length - 1) {
          // console.log('index > this.extentPoints.length - 1');
          return index - this.extentPoints.length;
        }

        return index;
      });

      if (this.selectedLines[1] - this.selectedLines[0] < 0) {
        sizes = sizes.reverse();
      }


      this.drawSizeLabel(sizes[0], this.extentPoints[indexes[0]].x - dem, this.extentPoints[indexes[0]].y - dem);
      this.drawSizeLabel(sizes[1], this.extentPoints[indexes[1]].x - dem, this.extentPoints[indexes[1]].y - dem);


      this.ctx.globalCompositeOperation = "destination-over";
      this.reCalcExtentPoints();
      this.drawExtentPoints();
      this.drawActivePoints();
      this.drawDropPoints();
      this.ctx.globalCompositeOperation = "source-over";

    } else {
      this.reCalcExtentPoints();
      this.drawExtentPoints();
      this.drawActivePoints();
      this.drawDropPoints();
    }
  };

  drawExtentPoints = () => {

    this.ctx.fillStyle = "lightgrey";

    for (let i = 0; i < this.extentPoints.length; i++) {
      this.ctx.beginPath();
      this.ctx.arc(this.extentPoints[i].x, this.extentPoints[i].y, 4, 0, 2 * Math.PI);
      this.ctx.fill();
      this.ctx.closePath();
    }

  };

  /**
   * точки за которые можно таскать бордеры
   */
  drawActivePoints = () => {

    this.ctx.fillStyle = "grey";

    for (let i = 0; i < this.activePoints.length; i++) {

      if (this.activePointIndex === i) {
        this.ctx.fillStyle = "red";
      } else {
        this.ctx.fillStyle = "grey";
      }

      this.ctx.beginPath();
      this.ctx.arc(this.activePoints[i].x, this.activePoints[i].y, 10, 0, 2 * Math.PI);
      this.ctx.fill();
      this.ctx.closePath();
    }

  };

  /**
   * Точки куда можно сдвинуть бордер
   */
  drawDropPoints = () => {
    this.ctx.fillStyle = "red";
    for (let i = 0; i < this.dropPoints.length; i++) {
      this.ctx.beginPath();
      this.ctx.arc(this.dropPoints[i].x, this.dropPoints[i].y, 2, 0, 2 * Math.PI);
      this.ctx.fill();
      this.ctx.closePath();
    }
  };

  drawSizeLabel = (size, _x, _y) => {

    size = parseFloat(size);

    if (!isNaN(size)) {

      const str = size.toFixed(1) + " м.";

      const x = _x + 7;
      const y = _y - 10;

      this.ctx.fillStyle = "white";
      this.ctx.lineWidth = 3;
      this.ctx.strokeStyle = "black";

      const rect = {
        x: x - 5,
        y: y - 23,
        width: str.length * 11,
        height: 30
      };

      const r = rect.x + rect.width;
      const b = rect.y + rect.height;
      const radius = 4;
      this.ctx.beginPath();
      this.ctx.moveTo(rect.x + radius, rect.y);
      this.ctx.lineTo(r - radius, rect.y);
      this.ctx.quadraticCurveTo(r, rect.y, r, rect.y + radius);
      this.ctx.lineTo(r, rect.y + rect.height - radius);
      this.ctx.quadraticCurveTo(r, b, r - radius, b);
      this.ctx.lineTo(rect.x + radius, b);
      this.ctx.quadraticCurveTo(rect.x, b, rect.x, b - radius);
      this.ctx.lineTo(rect.x, rect.y + radius);
      this.ctx.quadraticCurveTo(rect.x, rect.y, x + radius, rect.y);
      this.ctx.stroke();
      this.ctx.fill();

      this.ctx.fillStyle = "black";
      this.ctx.font = '22px Trebuchet MS, Arial, Helvetica, sans-serif';
      this.ctx.fillText(str, x, y);
    }

  };

  marksDraw = (current, previous, currentIndex) => {

    const length = Math.round(Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2)) / this.state.square);

    let result = [];

    for (let b = 0; b < length; b++) {

      let alfa = b / (length - b);
      let x = (previous.x + current.x * alfa) / (1 + alfa);
      let y = (previous.y + current.y * alfa) / (1 + alfa);

      result.push({x: x, y: y, apointdex: currentIndex});
    }

    return result;
  };

  defineLineAsRect = (point1, point2) => {
    const dx = point2.x - point1.x, dy = point2.y - point1.y;

    const lineLength = Math.sqrt(dx * dx + dy * dy);
    const lineRadianAngle = Math.atan2(dy, dx);
    let rectHeight = this.state.lineWidth * 3;

    return ({
      translateX: point1.x,
      translateY: point1.y,
      rotation: lineRadianAngle,
      rectX: 0,
      rectY: -rectHeight / 2,
      rectWidth: lineLength,
      rectHeight: rectHeight
    });
  };

  getHitExtentPoint = (x, y) => {
    this.ctx.strokeStyle = "transparent";
    for (let i = 0; i < this.extentPoints.length; i++) {
      this.ctx.beginPath();
      this.ctx.arc(this.extentPoints[i].x, this.extentPoints[i].y, 10, 0, 2 * Math.PI);
      this.ctx.stroke();
      if (this.ctx.isPointInPath(x, y)) {
        return i;
      }
    }
    return -1;
  };


  //point;
  setActivePoint = (x, y) => {

    if (this.activePointIndex !== null) {
      this.selectedLines = [this.activePointIndex === 0 ? this.activePoints.length : this.activePointIndex, this.activePointIndex + 1];
      this.activePoints[this.activePointIndex] = {
        x: x / this.props.sizes.scale,
        y: y / this.props.sizes.scale,
        extentIndex: this.getActivePoint()
      };
    }
  };

  getActivePoint = () => {
    if (this.activePointIndex !== null) {
      return this.activePoints[this.activePointIndex];
    }
    return null;
  };

  getHitActivePoint = (x, y) => {
    this.ctx.strokeStyle = "transparent";
    for (let i = 0; i < this.activePoints.length; i++) {
      this.ctx.beginPath();
      this.ctx.arc(this.activePoints[i].x, this.activePoints[i].y, 10, 0, 2 * Math.PI);
      this.ctx.stroke();
      if (this.ctx.isPointInPath(x, y)) {
        return i;
      }
    }
    return -1;
  };

  addExtentToActive = (extentIndex) => {

    let current = this.extentPoints[extentIndex];

    if (current) {
      this.activePoints.splice(current.apointdex, 0, current);
      current.extentIndex = extentIndex;
      delete current.apointdex;
      this.lastExtentSelected = extentIndex;
    }

    this.draw();
  };

  isHitActivePoint = (x, y) => {

    this.ctx.strokeStyle = "transparent";

    for (let i = 0; i < this.activePoints.length; i++) {

      this.ctx.beginPath();
      this.ctx.arc(this.activePoints[i].x, this.activePoints[i].y, 10, 0, 2 * Math.PI);
      this.ctx.stroke();

      if (this.ctx.isPointInPath(x, y)) {

        this.ctx.fillStyle = "red";
        this.ctx.arc(this.activePoints[i].x, this.activePoints[i].y, 10, 0, 2 * Math.PI);
        this.ctx.fill();
        this.activePointIndex = i;
        return true;

      }
      this.ctx.closePath();
    }
    return false;
  };

  deleteActivePoint = (index) => {
    if (this.activePoints.length === 3) return;

    if (this.activePoints[index].extentIndex && this.activePoints[index].extentIndex === this.lastExtentSelected) {
      this.lastExtentSelected = null;
    }
    this.activePoints.splice(index, 1);
    this.activePointIndex = null;
    this.draw();
    this.reflectSite();
  };

  reCalcActivePoints = (coordinates = this.props.coordinates) => {
    this.activePoints = this.getActivePoints(coordinates);
  };

  reCalcExtentPoints = () => {
    this.extentPoints = this.getExtentPoints();
  };
  reCalcDropPoints = () => {
    this.dropPoints = this.getDropPoints();
  };

  drawDropPointCircle = (dropIndex, x, y) => {
    this.ctx.beginPath();
    this.ctx.strokeStyle = "red";
    this.ctx.lineWidth = 2;

    this.selectedDropIndex = dropIndex;
    this.ctx.arc(x, y, 20, 0, 2 * Math.PI);
    this.ctx.stroke();
    this.ctx.closePath();
  };

  checkDropPoint = (x, y) => {
    const scale = this.props.sizes.scale;
    const dropPointPadding = 15;

    for (let i = 0; i < this.dropPoints.length; i++) {
      const dropPoint = this.dropPoints[i];

      if (
        x / scale > (dropPoint.x - dropPointPadding) &&
        y / scale > (dropPoint.y - dropPointPadding) &&
        x / scale < (dropPoint.x + dropPointPadding) &&
        y / scale < (dropPoint.y + dropPointPadding)
      ) {
        this.drawDropPointCircle(i, dropPoint.x, dropPoint.y);
        return;
      }
    }

    this.selectedDropIndex = null;
  };

  reflectSite = () => {

    this.activePoints = this.activePoints.filter((point) => {
      return !point.extentIndex;
    });

    let coordinates = [];

    this.activePoints.forEach((apoint) => {

      let dropPoints = this.dropPoints.filter((dpoint) => {
        return apoint.x === dpoint.x && apoint.y === dpoint.y;
      });

      if (dropPoints[0]) {
        coordinates.push(dropPoints[0].relative);
      }

    });

    this.props.updateCoordinates(coordinates);
  };

  drop = () => {

    if ((this.selectedDropIndex || this.selectedDropIndex === 0) && this.activePointIndex !== null) {

      if (this.activePoints[this.activePointIndex] && this.activePoints[this.activePointIndex].extentIndex && this.activePoints[this.activePointIndex].extentIndex === this.lastExtentSelected) {
        this.lastExtentSelected = null;
      }

      this.activePoints[this.activePointIndex] = {
        x: this.dropPoints[this.selectedDropIndex].x,
        y: this.dropPoints[this.selectedDropIndex].y
      };

      this.activePoints.forEach((apoint, aindex) => {

        this.activePoints.forEach((bpoint, bindex) => {
          if (apoint.x === bpoint.x && apoint.y === bpoint.y) {
            if (aindex !== bindex) {
              this.activePoints.splice(aindex, 1);
            }
          }
        });

      });

      this.reflectSite();

    } else {

      this.reCalcActivePoints();
      this.reCalcExtentPoints();
      this.reCalcDropPoints();

    }
    this.selectedLines = [];
  };

  handlerRightBthClick = (e) => {
    e.preventDefault();
    const {x, y} = this.getOffsetXY(e.clientX, e.clientY);

    const index = this.getHitActivePoint(x, y);

    if (index !== -1) {
      this.deleteActivePoint(index);
    } else {

      const eindex = this.getHitExtentPoint(x, y);
      if (eindex !== -1) {
        this.addExtentToActive(eindex);
      }
    }
    return false;
  };


  handlerMove = (e) => {
    const {x, y} = this.getOffsetXY(e.clientX, e.clientY);

    this.checkLineSizes(x, y);

    if (this.state.selected) {
      this.setActivePoint(x, y);
      this.draw();
      this.checkDropPoint(x, y);
    }
    if (this.state.selected === 'Site') {
      this.moveTo(x - this.state.oldPosition.x, y - this.state.oldPosition.y);
    }
    e.preventDefault();
  };

  handlerOnMouseDown = (e) => {
    const {x, y} = this.getOffsetXY(e.clientX, e.clientY);

    if (this.isHitActivePoint(x, y)) {

      this.setState({
        selected: this.ctx,
        style: {...this.state.style, cursor: 'move'}
      });

    } else {

      const oldPosition = {
        x: x - this.props.position.x,
        y: y - this.props.position.y
      };

      //oldPosition
      if (this.props.toggleSiteSelected(oldPosition, x, y)) {
        this.setState({selected: 'Site', oldPosition});
      } else {
        this.setState({selected: null, oldPosition: {}});
      }
    }

  };

  handlerOnMouseUp = (e) => {

    if (e.button === 0) {

      this.drop();
      this.activePointIndex = null;
      this.selectedDropIndex = null;
      this.draw();
    }

    this.props.toggleSiteSelected(null);
    this.setState({
      selected: null,
      selectedDropIndex: null,
      oldPosition: {}
    });
  };


  render() {

    return <canvas
      ref="siteCustom"
      width={this.props.sizes.width}
      height={this.props.sizes.height}

      onMouseUp={this.handlerOnMouseUp}
      onMouseDown={this.handlerOnMouseDown}
      onContextMenu={this.handlerRightBthClick}

      onMouseMove={this.handlerMove}

    />

  }
}

SiteCustom.propTypes = {
  sizes: PropTypes.object.isRequired,
  coordinates: PropTypes.array.isRequired,
  toggleSiteSelected: PropTypes.func,
  updateCoordinates: PropTypes.func,
  moveTo: PropTypes.func,
  zoom: PropTypes.func,
};

export default SiteCustom;
